export const CardTheme = {
  default: 'default',
  black: 'black',
} as const;

export type CardTheme = (typeof CardTheme)[keyof typeof CardTheme];
